"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var _default = function _default(props) {
  var form = props.form,
    field = props.field,
    options = props.options,
    questSettings = props.questSettings,
    showHeader = props.showHeader,
    showFooter = props.showFooter,
    settingsFieldName = props.settingsFieldName,
    _props$width = props.width,
    width = _props$width === void 0 ? '140px' : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? '112px' : _props$height,
    _props$isScrollView = props.isScrollView,
    isScrollView = _props$isScrollView === void 0 ? true : _props$isScrollView;
  var currentOption = options.find(function (option) {
    return field.value === option.handle;
  });
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, props, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames3["default"])(_style["default"].frameWrapper, _defineProperty({}, _style["default"].scrollView, isScrollView))
  }, options.map(function (option) {
    var item = /*#__PURE__*/_react["default"].createElement("label", {
      key: option.handle,
      className: (0, _classnames3["default"])(_style["default"].frame, _defineProperty({}, _style["default"].selected, field.value === option.handle))
    }, /*#__PURE__*/_react["default"].createElement("input", _extends({}, field, {
      checked: field.value === option.handle,
      value: option.handle,
      type: "radio"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].thumbnail,
      style: {
        width: width,
        height: height
      }
    }, typeof option.thumbnail === 'string' ? /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].image,
      style: {
        backgroundImage: "url(".concat(option.thumbnail, ")")
      }
    }) : option.thumbnail(_objectSpread({}, field.value === option.handle && {
      settings: (0, _get2["default"])(form.values, settingsFieldName)
    })), showHeader && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].header
    }), showFooter && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].footer
    })), option.label && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].label
    }, option.label));
    return option.tooltip ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: option.tooltip,
      key: option.handle
    }, item) : item;
  }))), currentOption && currentOption.settingsComponent && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: '1.5em'
    }
  }, /*#__PURE__*/_react["default"].createElement(currentOption.settingsComponent, {
    settingsFieldName: settingsFieldName,
    questSettings: questSettings || form.values
  })));
};
exports["default"] = _default;